/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import noImage from 'src/assets/images/no-image.jpeg';
import '../index.scss';
import useSort from 'src/hooks/useSort';
import { usePreventTranslate } from 'src/hooks/usePreventTranslate';
import { useMarket } from 'src/context/marketContext';

const onError = (e) => { e.target.src = noImage; };

const NINETY_DAYS = 90 * 24 * 60 * 60 * 1000;
const isRecentlyNew = (game) => {
  if (!game.isNew) return false;
  if (!game.created) return false;
  const created = typeof game.created === 'string'
    ? new Date(game.created) : game.created;
  return (Date.now() - created.getTime()) < NINETY_DAYS;
};

const volColor = (v) => {
  if (!v) return 'var(--text-muted)';
  const lv = v.toLowerCase();
  if (lv === 'high') return '#ff6b6b';
  if (lv === 'medium' || lv === 'med') return '#f0b429';
  return '#2ed573';
};
const volWidth = (v) => {
  if (!v) return '33%';
  const lv = v.toLowerCase();
  if (lv === 'high') return '100%';
  if (lv === 'medium' || lv === 'med') return '66%';
  return '33%';
};

function AllGames({ games }) {
  const { sortBy } = useSort();
  const { ui } = useMarket();


  return (
    <div className="game-grid">
      {games?.length > 0 && games.map((item, index) => (
        <Link
          key={item.code}
          to={`/game/${item.code}`}
          className="game-card"
          data-testid="game-card"
          data-game-code={item.code}
          style={{ animationDelay: `${Math.min(index * 0.02, 0.5)}s` }}
        >
          {/* Badges */}
          <div className="game-card__badges">
            {(sortBy === 'maxWin' || sortBy === 'rtp') && (
              <Tag type={sortBy} shouldPreventTranslate>
                {item[sortBy] || '-'}
                {item[sortBy] > 0 && (
                  (sortBy === 'maxWin' && (item.type === 'CASUAL' ? '' : '\u00D7'))
                  || (sortBy === 'rtp' && '%')
                )}
              </Tag>
            )}
            <div className="game-card__badges-right">
            </div>
          </div>

          {/* Image */}
          <div className="game-card__image">
            <img
              src={item.preview || noImage}
              onError={onError}
              loading="lazy"
              alt={item.name}
            />
            <div className="game-card__hover">
              <span className="game-card__hover-text">{ui.viewDetails}</span>
            </div>
          </div>

          {/* Info */}
          <div className="game-card__info">
            <div className="game-card__name">{item.name}</div>
            <div className="game-card__provider">Rectangle Games</div>
            <div className="game-card__metrics">
              <div className="metric">
                <span className="metric__label">RTP</span>
                <span className="metric__value notranslate">
                  {item.rtp ? `${item.rtp}%` : '-'}
                </span>
              </div>
              <div className="metric">
                <span className="metric__label">Max Win</span>
                <span className="metric__value notranslate">
                  {item.maxWin ? `${item.maxWin}${item.type === 'CASUAL' ? '' : '\u00D7'}` : '-'}
                </span>
              </div>
              <div className="metric">
                <span className="metric__label">Volatility</span>
                <div className="metric__vol">
                  <div
                    className="metric__vol-bar"
                    style={{
                      width: volWidth(item.volatility),
                      background: volColor(item.volatility),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}

AllGames.propTypes = { games: PropTypes.array };

function Tag({ type, children, shouldPreventTranslate = false }) {
  const { replaced, content } = usePreventTranslate(children);
  if (replaced) shouldPreventTranslate = true;
  return (
    <span className={`game-badge game-badge--${type} ${shouldPreventTranslate ? 'notranslate' : ''}`}>
      {content}
    </span>
  );
}

export default AllGames;
